import React from 'react';
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormSpecimen } from './FormSpecimen';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { Dialog } from 'primereact/dialog';

export const ModalSpecimens = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, abbreviation, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete
    } = props;

    const footer = (
        <div>
            <Button
                color="secondary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>
        </div>
    );


    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            blockScroll
            footer={footer}
            closable={false}
            modal
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-flask f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}
            maskClassName="custom-total-mask"
            className={`Global-dialog Global-dialog Global-blue Global-small-v`}

        >
            {
                method === "create"
                    ?
                    <FormSpecimen
                        button={ModalButtonSave}
                        {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormSpecimen
                            button={ModalButtonUpdate}
                            {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }}
                        />
                        :
                        null
            }
        </Dialog>


    )
}
